
<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p>
                <strong>Blendle2020</strong> by <a href="https://www.blendle2020.kleinprodesign.nl/">Bram Klein</a>. The source code is licensed
                <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
                is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
            </p>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>